/**
 * Grafik ranglari — yagona manba `styles.css` dagi `--chart-*` tokenlari.
 *
 * Nega oddiy satr, hook emas: recharts rang qiymatini O'ZI tahlil qilmaydi
 * (`grep "hsl(" node_modules/recharts` — nol natija), u `fill`/`stroke`/
 * `stopColor` ni to'g'ridan-to'g'ri SVG prezentatsion atributiga uzatadi.
 * Prezentatsion atribut esa CSS xossasi sifatida qo'llanadi, ya'ni `var()`
 * o'rniga qo'yish ishlaydi va rang PAINT vaqtida hal bo'ladi. Natijada mavzu
 * almashganda grafiklar qayta render'siz qayta ranglanadi — `getComputedStyle`
 * o'qiydigan hook kerak emas (u faqat ortiqcha qatlam bo'lardi).
 *
 * Ilgari ranglar sahifalarga hex bo'lib sochilgandi (`#3b82f6`, `#10b981`…) —
 * shuning uchun grafiklar qorong'i rejimga umuman javob bermasdi.
 */
export type ChartToken =
  | "chart-1"
  | "chart-2"
  | "chart-3"
  | "chart-4"
  | "chart-5"
  | "chart-6"
  | "chart-positive"
  | "chart-negative"
  | "chart-neutral"
  | "chart-grid";

/** Token → recharts prop'iga beriladigan rang satri. */
export function chartColor(token: ChartToken): string {
  return `hsl(var(--${token}))`;
}

/** `CartesianGrid` uchun umumiy prop'lar — har grafikda takrorlanmasin. */
export const CHART_GRID_PROPS = {
  strokeDasharray: "3 3",
  stroke: chartColor("chart-grid"),
} as const;

/** `XAxis`/`YAxis` uchun umumiy prop'lar. */
export const CHART_AXIS_PROPS = {
  fontSize: 11,
  stroke: "hsl(var(--muted-foreground))",
  tickLine: false,
} as const;

/**
 * `Tooltip` uchun umumiy uslub. Recharts'ning standart ko'pigi `#fff` fonni
 * INLINE style bilan beradi (`node_modules` ichida), ya'ni qorong'i rejimda oq
 * quti bo'lib chiqardi — shuning uchun uni token bilan almashtiramiz.
 */
export const CHART_TOOLTIP_PROPS = {
  contentStyle: {
    background: "hsl(var(--card))",
    border: "1px solid hsl(var(--border))",
    borderRadius: "var(--radius)",
    color: "hsl(var(--card-foreground))",
    fontSize: 12,
  },
  labelStyle: { color: "hsl(var(--muted-foreground))" },
  itemStyle: { color: "hsl(var(--card-foreground))" },
  cursor: { fill: "hsl(var(--muted))", fillOpacity: 0.4 },
} as const;
